import { FromSchema } from '@40seas/entities/common';
import { z } from 'zod';
import { AiprizeBusinessActivity, AiprizeBusinessActivitySchema } from './aiprize.business-activity.entity';

export const AiprizeBusinessScopeSchema = z
    .object({
        businessActivities: z.array(AiprizeBusinessActivitySchema).optional(),
        businessDescription: z.string().optional(),
    })
    .strict();

export class AiprizeBusinessScope extends FromSchema(AiprizeBusinessScopeSchema) {
    businessActivities?: AiprizeBusinessActivity[];
    businessDescription?: string;
}
